import { LoginPage } from "@/pages/login";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth_not_requeired/login")({
  component: () => <LoginPage />,
});
